import heart from "./cross-section.png";

import davb_b from "./1dAVb/blue.png";
import davb_r from "./1dAVb/red.png";
import davb_y from "./1dAVb/yellow.png";

import af_b from "./AF/blue.png";
import af_r from "./AF/red.png";
import af_y from "./AF/yellow.png";

import lbbb_b from "./LBBB/blue.png";
import lbbb_r from "./LBBB/red.png";
import lbbb_y from "./LBBB/yellow.png";

import rbbb_b from "./RBBB/blue.png";
import rbbb_r from "./RBBB/red.png";
import rbbb_y from "./RBBB/yellow.png";

import sb_b from "./SB/blue.png";
import sb_r from "./SB/red.png";
import sb_y from "./SB/yellow.png";

import st_b from "./ST/blue.png";
import st_r from "./ST/red.png";
import st_y from "./ST/yellow.png";

const images = {
    heart: heart,
    davb: {
        b: davb_b,
        r: davb_r,
        y: davb_y,
    },
    af: {
        b: af_b,
        r: af_r,
        y: af_y,
    },
    lbbb: {
        b: lbbb_b,
        r: lbbb_r,
        y: lbbb_y,
    },
    rbbb: {
        b: rbbb_b,
        r: rbbb_r,
        y: rbbb_y,
    },
    sb: {
        b: sb_b,
        r: sb_r,
        y: sb_y,
    },
    st: {
        b: st_b,
        r: st_r,
        y: st_y,
    },
};

export const imagesOrdered = [
    images.davb,
    images.rbbb,
    images.lbbb,
    images.sb,
    images.af,
    images.st,
];

export default images;
